import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();

export class ZIDXAccountSiteUserEdit implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountSiteUserEditContainer";
    }


    render() {
        // console.log("site user edit");
        let self=this;

        $(".idxAgentModalLookupLink", this.zidx.peakidxShadowRoot).on("click", function(this:HTMLElement, e:JQuery.ClickEvent) {
            e.preventDefault();
            let link=this.getAttribute("data-link")!;
            let field=this.getAttribute("data-field")!;
            let listingIndex=this.getAttribute("data-index-id")!;
            let modalContent1='<iframe src="'+link+"?listing_index_id="+listingIndex+'&field='+field+'"  style="margin:0px;border:none; overflow:auto;" seamless="seamless" width="100%" height="95%"><\/iframe>';
            // @ts-ignore
            self.zidx.modalWindow.showModal(modalContent1,{'width':self.zidx.windowSize.width-100,'height':self.zidx.windowSize.height-100});
            return false;
        });

        $(".idxOfficeModalLookupLink", this.zidx.peakidxShadowRoot).on("click", function(this:HTMLElement, e:JQuery.ClickEvent) {
            e.preventDefault();
            let link=this.getAttribute("data-link")!;
            let field=this.getAttribute("data-field")!;
            let listingIndex=this.getAttribute("data-index-id")!;
            let modalContent1='<iframe src="'+link+"?listing_index_id="+listingIndex+'&field='+field+'"  style="margin:0px;border:none; overflow:auto;" seamless="seamless" width="100%" height="95%"><\/iframe>';
            // @ts-ignore
            self.zidx.modalWindow.showModal(modalContent1,{'width':self.zidx.windowSize.width-100,'height':self.zidx.windowSize.height-100});
            return false;
        });
    }
}